import { computed } from 'vue';
import { useI18n } from '@/composables/useI18n';

export const buildDimensionsLabels = (translate: (key: string) => string) => ({
  campaigns: translate('Campaigns'),
  offers: translate('Offers'),
  landings: translate('Landings'),
  'hour-of-day': translate('Hour Of Day'),
  'day-of-week': translate('Day Of Week'),
  flows: translate('Flows'),
  'traffic-sources': translate('Traffic Sources'),
  'affiliate-networks': translate('Affiliate Networks'),
  day: translate('Day'),
  month: translate('Month'),
  custom1: translate('Custom 1'),
  custom2: translate('Custom 2'),
  custom3: translate('Custom 3'),
  custom4: translate('Custom 4'),
  custom5: translate('Custom 5'),
  custom6: translate('Custom 6'),
  custom7: translate('Custom 7'),
  custom8: translate('Custom 8'),
  custom9: translate('Custom 9'),
  custom10: translate('Custom 10'),
  referrers: translate('Referrers'),
  states: translate('State / region'),
  'referrer-domains': translate('Referrer Domain'),
  countries: translate('Countries'),
  'mobile-carriers': translate('Mobile Carriers'),
  'connection-types': translate('Connection Types'),
  cities: translate('Cities'),
  isps: translate('ISP'),
  'browser-versions': translate('Browser Versions'),
  oses: translate('OS'),
  'os-versions': translate('OS Versions'),
  browsers: translate('Browsers'),
  'device-models': translate('Device Models'),
  'device-types': translate('Device Types'),
  languages: translate('Languages'),
  'device-vendors': translate('Device Vendors'),
  ips: translate('IP'),
  'subnet-small': translate('Subnet Small'),
  'subnet-big': translate('Subnet Big'),
  'screen-resolutions': translate('Screen Resolutions'),
  useragents: translate('User Agents'),
  'live-visits': translate('Live Visits'),
  'live-clicks': translate('Live Clicks'),
  n_a: translate('n/a'),
  conversions: translate('Conversions'),
  errors: translate('Errors'),
  flow_rules: translate('Flow rule'),
  flow_rule_paths: translate('Flow path'),
});

export const useDimensionsLabels = () => {
  const { t } = useI18n();

  const dimensions = computed(() => buildDimensionsLabels(t));

  return {
    dimensions,
  };
};
